import { Button, Col, Input, Row } from "reactstrap";
import styles from "./AddNewVoucher.module.scss";
import { useState } from "react";
import Multiselect from "../../../../../components/common/MultiselectDropdown/Multiselect";
import SelectCustomersModal from "./SelectCustomersModal/SelectCustomersModal";
import SelectProductsModal from "./SelectProductsModal/SelectProductsModal";
import AddedCustomers from "./AddedCustomers/AddedCustomers";
import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const AddNewVoucher = () => {
  const [isSelectCustomersModalOpen, setIsSelectCustomersModalOpen] =
    useState(false);
  const [isSelectProductsModalOpen, setIsSelectProductsModalOpen] =
    useState(false);
  const [showSelectedCustomers, setShowSelectedCustomers] = useState(false);
  const [customizationValue, setCustomizationValue] = useState(null);

  return (
    <div>
      <div>
        <YellowHeaderWrapper title="General Information">
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Voucher Name</Col>
            <Col lg="5" xxl="4">
              <Input placeholder="Enter name of the voucher" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Voucher Code:</Col>
            <Col lg="5" xxl="4">
              <Multiselect
                title="Choose from dropdown menu"
                options={["Store Credit", "Product Specific"]}
              />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Voucher Type:</Col>
            <Col lg="5" xxl="4">
              <Multiselect
                title="Choose from dropdown menu"
                options={[
                  "Percentage off",
                  "Delivery discount",
                  "Buy 1 get 1 free",
                ]}
              />
            </Col>
          </Row>
        </YellowHeaderWrapper>
      </div>

      <div>
        <YellowHeaderWrapper title="Details">
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Validity Period:</Col>
            <Col lg="6" xxl="5">
              <Row className="g-0">
                <Col lg="5">
                  <Input type="date" />
                </Col>
                <Col
                  lg="2"
                  className="d-flex justify-content-center align-items-center fw-bold"
                >
                  -
                </Col>
                <Col lg="5">
                  <Input type="date" />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Distribution method:</Col>
            <Col lg="5" xxl="4">
              <Multiselect
                title="Choose from dropdown"
                options={["SMS", "Email"]}
              />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Monetary Value:</Col>
            <Col lg="5" xxl="4">
              <Multiselect
                title="Choose from dropdown"
                options={["Store page", "Product detail page"]}
              />
            </Col>
          </Row>
        </YellowHeaderWrapper>
      </div>

      <div>
        <YellowHeaderWrapper title="Conditions">
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Minimum Purchase Value:</Col>
            <Col lg="5" xxl="4">
              <Input placeholder="Enter name of the product" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Apply to:</Col>
            <Col lg="5" xxl="4">
              <Multiselect
                title="Choose from dropdown"
                options={["General use/Specific products"]}
              />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg="3" xxl="2">Target Customer:</Col>
            <Col lg="5" xxl="4">
              <Multiselect
                title="Choose from dropdown"
                options={[
                  "New customers",
                  "Frequent buyers",
                  "Individual customers",
                ]}
              />
            </Col>
          </Row>
          {showSelectedCustomers && <AddedCustomers />}
        </YellowHeaderWrapper>
      </div>

      {/*  Product selection  */}
      {/* <ProductSelection /> */}

      <div>
        <YellowHeaderWrapper title="Customization">
          <ReactQuill
            theme="snow"
            value={customizationValue}
            onChange={setCustomizationValue}
            placeholder="Gift Voucher"
            className={styles.codeEditor}
          />
        </YellowHeaderWrapper>
      </div>

      <div className="d-flex justify-content-center">
        <div className={styles.BtnContainer}>
          <button className={styles["btn"]}>Cancel</button>

          <Button
            type="button"
            color="primary"
            className={styles.Btn}
            onClick={() => { }}
          >
            Send Voucher
          </Button>
        </div>
      </div>
      <SelectCustomersModal
        isModalOpen={isSelectCustomersModalOpen}
        setIsModalOpen={setIsSelectCustomersModalOpen}
      />
      <SelectProductsModal
        isModalOpen={isSelectProductsModalOpen}
        setIsModalOpen={setIsSelectProductsModalOpen}
      />
    </div>
  );
};

export default AddNewVoucher;